(function () {
    'use strict';

    angular
        .module('wsl.core')
        .factory('environmentService', environmentService);

    environmentService.$inject = [''];

    /* @ngInject */
    function environmentService() {
        var service = {
            getBrowser: getBrowser,
            getOs: getOs
        };

        return service;

        ////////////////

        function getBrowser() {
            var ua = navigator.userAgent, tem,
                M = ua.toLowerCase().match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*([\d\.]+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+(\.\d+)?)/g.exec(ua) || [];
                return 'IE ' + (tem[1] || '');
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.toLowerCase().match(/version\/([\.\d]+)/i)) != null) {
                M[1] = tem[1];
            }
            return {name: M[0].toLowerCase(), version: M[1]};
        }

        function getOs() {
            var OSName = 'Unknown OS';
            if (navigator.userAgent.indexOf('Win') != -1) {
                OSName = 'Windows';
            }
            if (navigator.userAgent.indexOf('Mac') != -1) {
                OSName = 'MacOS';
            }
            if (navigator.userAgent.indexOf('X11') != -1) {
                OSName = 'UNIX';
            }
            if (navigator.userAgent.indexOf('Linux') != -1) {
                OSName = 'Linux';
            }
            return OSName;
        }
    }
})();
